import React from 'react';
import Cookies from 'universal-cookie';
import Link from 'next/link';

import styles from './../styles/LanguagePicker.module.scss';
import Image from 'next/image';

import LanguagePLIcon from './../public/images/language/pl.svg';
import LanguageDEIcon from './../public/images/language/de.svg';
import LanguageENIcon from './../public/images/language/en.svg';
import LanguageITIcon from './../public/images/language/it.svg';
import DropdownIcon from './../public/images/dropdown.svg';

import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';

const cookies = new Cookies();

const languages = [
  {
    name: 'PL',
    fullName: 'POLSKI',
    locale: 'pl',
    lsKey: 'pl',
    icon: LanguagePLIcon
  },
  {
    name: 'EN',
    fullName: 'ENGLISH',
    locale: 'uk',
    lsKey: 'en-GB',
    icon: LanguageENIcon
  },
  {
    name: 'DE',
    fullName: 'DEUTSCH',
    locale: 'de',
    lsKey: 'de-DE',
    icon: LanguageDEIcon
  },
  {
    name: 'IT',
    fullName: 'ITALIANO',
    locale: 'it',
    lsKey: 'it-IT',
    icon: LanguageITIcon
  }
];

const LanguagePicker: React.FC<{ footer?: boolean }> = ({ footer }) => {
  const { t } = useTranslation('common');

  const { locale } = useRouter();

  const currentLang = useMemo(
    () =>
      languages.find(l => l.locale === locale) ?? {
        name: '',
        icon: '',
        locale: '',
        lsKey: ''
      },
    [locale]
  );

  useEffect(() => {
    cookies.set('language', currentLang.locale, {
      path: '/'
    });
    localStorage.setItem('language', currentLang.lsKey);
  }, [currentLang]);

  return (
    <div
      className={`dropdown ${styles.languagePicker} ${
        footer ? styles.footerDropdown : ''
      }`}
    >
      {footer ? null : (
        <div className={`${styles.languageContainer}`}>
          <Image src={currentLang.icon} alt={currentLang.name} />
          <Link href="/" locale={currentLang.locale}>
            {currentLang.name}
          </Link>
          <Image src={DropdownIcon} alt="Dropdown icon" />
        </div>
      )}
      <div
        className={`dropdown-content ${
          footer ? styles.footerDropdownContent : ''
        }`}
      >
        <div
          className={`${styles.languageContainer} ${
            footer ? styles.firstLanguageContainer : ''
          }`}
        >
          <span
            className={`${styles.languageText} ${
              footer ? styles.footerLanguageText : ''
            }`}
          >
            {t('language')}
          </span>
        </div>

        {languages
          .filter(l => (footer ? l : l.locale !== locale))
          .map(l => (
            <div
              key={l.locale}
              className={`${styles.languageContainer} ${
                footer ? styles.languageFooterContainer : ''
              }`}
            >
              <Image
                src={l.icon}
                alt={l.name}
                width={18}
                height={18}
                layout="fixed"
              />
              <Link href={l.locale === 'pl' ? '/pl' : '/'} locale={l.locale}>
                {footer ? l.fullName : l.name}
              </Link>
            </div>
          ))}
      </div>
    </div>
  );
};

export default LanguagePicker;
